import React from 'react'
import mod from "./Pages.module.css";
import SignupForm from '../components/Forms/SignupForm';
import { Link } from 'react-router-dom';
import Card from '../components/Cards/Card';
import Button from '../components/Buttons/Button';

function SignupPage() {
  return (
    <div className={mod.signupPage}>
    <Card className={mod.FormCard}>
       <h1>New Account</h1>
       <SignupForm />
       <div className={mod.control}>
          <p>If you already have an account go back to Login page and log in</p>
          <Link to="/login">
             <Button className={mod.switchBtn}>Back to Login</Button>
          </Link>
       </div>
    </Card>
 </div>
  )
}

export default SignupPage